import { Box, IconButton, Typography } from '@mui/material';
import React, { useState } from 'react';
import { BarChart, Bar, Cell, XAxis, YAxis, CartesianGrid, Legend, Tooltip, ResponsiveContainer } from 'recharts';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { toCurrency, toFormatedNumber } from '../utils/helpers';
import { Info } from '@mui/icons-material';
import { Tooltip as InfoIcon } from '@mui/material';
var _ = require('lodash');

type ChartData = {
    data: string,
    qtde_item: number,
    mean_preco: number,
    median_preco: number,
    mes: number,
    ano: number,

}

type Props = {
    axisName: string,
    label: string,
    info?: string,
    color: string,
    field: keyof ChartData,
    type: "sum" | "avg",
    data: ChartData[]
    print: boolean,
}

function Chart({ axisName, label, info, data, color, type, field, print }: Props) {
    const [groupBy, setGroupBy] = useState<string>("month");

    const convert = (number: string | number): number => typeof number === "string" ? parseFloat(number) : number;

    const groupedData = () => {
        const mapped: { label: string, value: number }[] = data.map((d: ChartData) => (
            { label: groupBy === "month" ? `${d.mes}/${d.ano}` : `${d.ano}`, value: convert(d[field]) }
        ));
        const labels: string[] = _.uniq(mapped.map(d => d.label));
        const response = [];
        for (const label of labels) {
            response.push({
                label: label,
                value: mapped
                    .filter(d => d.label === label)
                    .reduce((prev, current) => type === "sum"
                        ? prev + current.value
                        : (prev + current.value) / 2, 0
                    )
            })
        }
        return response;
    }

    const formatCash = (n: number) => {
        if (n < 1e3) return n;
        if (n >= 1e3 && n < 1e6) return +(n / 1e3).toFixed(1) + "K";
        if (n >= 1e6 && n < 1e9) return +(n / 1e6).toFixed(1) + "M";
        if (n >= 1e9 && n < 1e12) return +(n / 1e9).toFixed(1) + "B";
        if (n >= 1e12) return +(n / 1e12).toFixed(1) + "T";
    };


    const formatter = (value: any) => `R$${formatCash(+value)}`;

    return (<div className='rounded shadow'>
        <div className='border-b mb-4 px-4 py-2 flex items-center'>
            <div className='flex-1'>
                <Box display="flex" alignItems="center">
                    <Typography variant='h6'>{label}</Typography>

                    {info ? <InfoIcon title={info}>
                        <IconButton>
                            <Info />
                        </IconButton>
                    </InfoIcon> : <></>}


                </Box>

            </div>
            <div className='flex-1 text-right'>
                <ToggleButtonGroup
                    value={groupBy}
                    exclusive
                    onChange={(event, newValue) => setGroupBy(newValue)}
                    size="small"
                >
                    <ToggleButton value="month">mês</ToggleButton>
                    <ToggleButton value="year">ano</ToggleButton>
                </ToggleButtonGroup>
            </div>
        </div>


        <BarChart
            width={print ? 500 : 600}
            height={print ? 300 : 400}
            data={groupedData()}
            margin={{
                top: 5,
                right: 30,
                left: 20,
                bottom: 5,
            }}
        >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="label" />
            <YAxis tickFormatter={formatter} />
            <Tooltip formatter={(value: any) => type === "sum" ? toFormatedNumber(value) : toCurrency(value)} />
            <Legend />
            <Bar dataKey="value" fill={color} name={axisName} />
        </BarChart>
    </div>);
}

export default Chart;
